import ModalContainer from "../common/modal_container";

import liceseBanner from "../../_asset/banner/License_evolution.png"
import liceseBanner_pc from "../../_asset/banner/License_evolution_pc.png"
import liceseBanner_mo from "../../_asset/banner/License_evolution_mo.png"
import { isMobile } from "react-device-detect";

export default function LicenseBannerPopupEvolution({popShow, setPopShow}: {popShow: boolean, setPopShow: Function}){
    return (        
        <ModalContainer show={popShow}
                        setShow={setPopShow}
                        closeBtn={true}
                        centered={true}
                        // className={'license-banner-evolution'}
                        className={'license-banner evolution'}
        >
            <img src={isMobile ? liceseBanner_mo : liceseBanner_pc} alt="" />
            {/* <img src={liceseBanner} alt="" />
            <div>
                <p>Evolution Gaming</p>
                <p>정식 계약서</p>
            </div> */}
        </ModalContainer>
    )
}